import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Button,
  Link,
  Navbar,
  NavRight,
  Page,
  Popup,
  List,
  ListInput
} from 'framework7-react';
import II18 from '../translate/II18';
import { gae } from '../helpers/Analytics';
import { DOC_TYPE_FORM, DOC_TYPE_PDF_FORM, getIcon } from '../helpers/utils';
import { reduxTools } from '../../redux/actions/reduxTools';
import {
  HIDE_REJECT_DOCUMENT_DIALOG,
  setDocumentRejected
} from '../../redux/actions/rootAction';
import PaperflyAPI from '../../server/api/PaperflyAPI';
import { esMapToJsonObject } from '../helpers/formUtils';

export default function RejectDocumentPopUp() {
  const [rejectReason, setRejectReason] = React.useState('');
  const [rejectConfirmed, setRejectConfirmed] = React.useState(false);

  const dispatch = useDispatch();
  const dialogOpened = useSelector(state =>
    Boolean(state.showRejectDocumentDialog)
  );
  const recipientRequestId = useSelector(state => state.recipientRequestId);
  const documentToReject = useSelector(state =>
    state.requestedDocuments.get(state.showRejectDocumentDialog?.docId)
  );
  const oneDocumentRequest = useSelector(
    state => state.requestedDocuments.size === 1
  );
  const dynamicRequest = useSelector(state => state.requestPages?.length > 0);
  const formData = useSelector(state =>
    state.forms.get(state.showRejectDocumentDialog?.docId)
  );
  const needData =
    documentToReject?.type === DOC_TYPE_PDF_FORM ||
    documentToReject?.type === DOC_TYPE_FORM;

  const onClose = () => {
    dispatch(reduxTools.createAction(HIDE_REJECT_DOCUMENT_DIALOG));
  };

  useEffect(() => {
    if (!dialogOpened && rejectConfirmed) {
      dispatch(setDocumentRejected(rejectConfirmed));
      setRejectConfirmed(false);
    }
    setRejectReason('');
  }, [dialogOpened, rejectConfirmed, dispatch]);

  const doRejectDocument = () => {
    const jsonData = esMapToJsonObject(formData);
    PaperflyAPI.rejectDocument(
      recipientRequestId,
      documentToReject?.id,
      rejectReason,
      needData ? jsonData || {} : {}
    ).then(
      () => {
        setRejectConfirmed(documentToReject?.id);
        onClose();
      },
      () => {}
    );
  };

  return (
    <Popup
      id={'reject_document_popup'}
      className="reject_document_popup"
      animate={false}
      opened={dialogOpened}
      swipeToClose={false}
      closeByBackdropClick={false}
      closeOnEscape={false}
      onPopupOpen={() => gae('REJECT_DOCUMENT_POPUP', 'SHOW')}
      style={window.isDesktop ? { height: 'auto', marginTop: -215 } : {}}
    >
      <Page style={{ background: '#fff', position: 'relative' }}>
        <Navbar title={II18.get('reject_document_title')}>
          <NavRight>
            <Link onClick={onClose}>{getIcon('material:clear')}</Link>
          </NavRight>
        </Navbar>

        {documentToReject && (
          <div
            style={{ display: 'flex', flexDirection: 'column', padding: 20 }}
          >
            <p
              style={{
                fontSize: 14,
                marginBottom: 40,
                color: '#333',
                padding: 0,
                margin: 0
              }}
            >
              {II18.get('reject_document_info', documentToReject.name)}
            </p>

            <List
              noHairlines
              noHairlinesBetween
              style={{ padding: 0, margin: 0 }}
            >
              <ListInput
                value={rejectReason}
                onChange={e => setRejectReason(e.target.value)}
                type={'textarea'}
                outline
                label={II18.get('reject_document_reason')}
                floatingLabel
                placeholder={II18.get('reject_document_reason_placeholder')}
                clearButton
              ></ListInput>
            </List>
          </div>
        )}

        <div
          className="dialogBottomBar"
          style={{
            position: 'inherit',
            display: 'flex',
            justifyContent: 'end',
            margin: '15px 20px'
          }}
        >
          <Button onClick={onClose}>
            <II18 get={'title_cancel'} />
          </Button>
          <Button
            onClick={doRejectDocument}
            fill
            color="red"
            disabled={!rejectReason}
          >
            <II18
              get={
                oneDocumentRequest && !dynamicRequest
                  ? 'title_reject_and_send'
                  : 'title_reject'
              }
            />
          </Button>
        </div>
      </Page>
    </Popup>
  );
}
